// ArChat Auto-Normalized File
// Created: 12-03-2026 22:38:36
// Author: SIVOL® - Aldo Frias - Argentina

/**
 * Autor: SIVOL® - Aldo Frias - Argentina
 * Fecha: 11/03/2026 22:50 (Argentina - UTC-3)
 * Breadcrumbs para observabilidad de errores.
 * Guarda en memoria los últimos 20 eventos (rutas, API, clics, cambios de vista).
 * @file frontend/src/services/errorBreadcrumbs.js
 */

const MAX_BREADCRUMBS = 20;
const store = [];

/**
 * @typedef {{ type: 'route'|'api'|'click'|'view', value: string, ts: number }} BreadcrumbEntry
 */

/**
 * Añade un evento al historial (máx 20).
 * @param {string} type - 'route' | 'api' | 'click' | 'view'
 * @param {string} value - Ruta, endpoint, id del elemento o descripción
 */
export function addBreadcrumb(type, value) {
  if (typeof type !== 'string' || typeof value !== 'string') return;
  const entry = {
    type: type.slice(0, 20),
    value: value.slice(0, 255),
    ts: Date.now(),
  };
  store.push(entry);
  if (store.length > MAX_BREADCRUMBS) {
    store.shift();
  }
}

/**
 * Devuelve una copia de los breadcrumbs actuales (para enviar con el reporte de error).
 * @returns {BreadcrumbEntry[]}
 */
export function getBreadcrumbs() {
  return store.slice(0);
}

/**
 * Registra un cambio de ruta (para uso en useLocation / Router).
 * @param {string} path - pathname actual
 */
export function breadcrumbRoute(path) {
  addBreadcrumb('route', path || '/');
}

/**
 * Registra una llamada API (para usar en apiClient).
 * @param {string} endpoint - URL o path del endpoint
 */
export function breadcrumbApi(endpoint) {
  addBreadcrumb('api', endpoint || '');
}

/**
 * Registra un clic relevante (p. ej. "Invitar", "Enviar").
 * @param {string} id - Identificador del elemento o acción
 */
export function breadcrumbClick(id) {
  addBreadcrumb('click', id || '');
}

/**
 * Limpia el buffer (opcional, p. ej. al cerrar sesión).
 */
export function clearBreadcrumbs() {
  store.length = 0;
}
